// extracted by mini-css-extract-plugin
export var card = "_lq-1";
export var summary = "_lq-0";